import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./double-chevron-left.svg?react";

export const DoubleChevronLeftIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
